<div class="agec-page">
    <picture class="agec-page-image">
        @for (agecImageSrc of agecImageSrcSet; track agecImageSrc) {
        <source [attr.srcset]="agecImageSrc.srcSet" [attr.media]="agecImageSrc.mediaQuery" />
        }
        <img [attr.src]="this.agecImageFullPath + '?fit=wrap&wid=414'" alt="" />
    </picture>
    <div #search class="container">
        <h1 class="display-light" i18n="@@hermes.environment.title">Empreinte écologique</h1>
        <h-agec-search-bar
            #searchBar
            [skuNotFound]="skuNotFound"
            (formSubmit)="onFormSubmit($event)"></h-agec-search-bar>
        <p i18n="@@hermes.environment.text" class="info-agec paragraph-small">
            Renseignez dans la barre de recherche la référence indiquée sur la facture, sur l’étiquette, ou sur la page
            consacrée au produit.
        </p>
    </div>
    @if (product) {
    <h-agec-search-result [product]="product"></h-agec-search-result>
    }
    <h-agec-packagings></h-agec-packagings>
</div>
